import { FC } from 'react';
import Card from 'components/atoms/Card';
import Image from 'next/image';
import styles from './VerticalServiceFlowStep.module.scss';

interface Props {
  description: string;
  imageUrl: string;
  stepNumber: number;
  title: string;
}

export const VerticalServiceFlowStep: FC<Props> = ({
  description,
  imageUrl,
  stepNumber,
  title,
}) => (
  <div className={styles['container']}>
    <Image
      alt={title}
      className={styles.image}
      height={343}
      src={imageUrl}
      unoptimized={true}
      width={343}
    />
    <h3>
      {stepNumber}. {title}
    </h3>
    <Card>{description}</Card>
  </div>
);

export default VerticalServiceFlowStep;
export type { Props as VerticalServiceFlowStepProps };
